import { setup } from 'twind/shim';
export { disconnect } from 'twind/shim';
import { apply } from 'twind';
export { apply, tw } from 'twind';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Primary = {
	"blue-1": {
		value: "#d1effa"
	},
	"blue-2": {
		value: "#84d1eb"
	},
	"blue-3": {
		value: "#2fabd5"
	},
	"blue-4": {
		value: "#3186af"
	},
	"blue-5": {
		value: "#265973"
	},
	"blue-6": {
		value: "#1d4153"
	},
	"pink-1": {
		value: "#fff6f2"
	},
	"pink-2": {
		value: "#fff0eb"
	},
	"pink-3": {
		value: "#ffd5c8"
	},
	"pink-4": {
		value: "#e58c71"
	},
	"Pink-5": {
		value: "#d66a49"
	},
	"pink-0": {
		value: "#fffbf9"
	}
};

var Secondary = {
	"cobalt-blue-1": {
		value: "#f0f5ff"
	},
	"cobalt-blue-3": {
		value: "#2e62d6"
	},
	"green-1": {
		value: "#eefff6"
	},
	"green-3": {
		value: "#10c767"
	},
	"purple-1": {
		value: "#f8ecff"
	},
	"purple-3": {
		value: "#a734ee"
	},
	"red-1": {
		value: "#ffe9e8"
	},
	"red-3": {
		value: "#ea4335"
	},
	"red-4": {
		value: "#b10e00"
	},
	"teal-1": {
		value: "#e6faf7"
	},
	"teal-3": {
		value: "#21c6b2"
	},
	"yellow-1": {
		value: "#fff9eb"
	},
	"yellow-3": {
		value: "#ebae12"
	},
	"cobalt-blue-4": {
		value: "#2450b2"
	}
};

var Neutral = {
	"grey-1": {
		value: "#f9fafa"
	},
	"grey-2": {
		value: "#eff7fb"
	},
	"grey-3": {
		value: "#e2f1f8"
	},
	"grey-4": {
		value: "#c9dfe8"
	},
	"grey-5": {
		value: "#9ebdcb"
	},
	"grey-6": {
		value: "#668a99"
	},
	"grey-7": {
		value: "#526e7a"
	},
	"grey-8": {
		value: "#33454c"
	},
	"grey-9": {
		value: "#22262a"
	},
	white: {
		value: "#ffffff"
	},
	"grey-0": {
		value: "#959595"
	}
};

var shadow$5 = {
	login: {
		card: {
			value: " 0.0px 34.0px 60.0px 0px rgba(0, 0, 0, 0.15)"
		}
	}
};

var shadow$4 = {
	chat: {
		"chat-icon-shadow": {
			value: " 0.0px 24.0px 24.0px 0px rgba(0, 0, 0, 0.35)"
		}
	}
};

var shadow$3 = {
	dropdown: {
		"dropdown-big": {
			value: " 0.0px 24.0px 24.0px 1.0px rgba(0, 0, 0, 0.12)"
		}
	}
};

var shadow$2 = {
	button: {
		"shadow-hover": {
			value: " 0.0px 8.0px 15.0px 1.0px rgba(150, 150, 150, 0.25)"
		},
		"shadow-label": {
			value: " 0.0px 0.0px 2.0px 0px rgba(29, 29, 29, 0.55)"
		},
		"shadow-pressed": {
			value: " 0.0px 4.0px 5.0px 1.0px rgba(150, 150, 150, 0.6)"
		}
	}
};

var shadow$1 = {
	sidebar: {
		"sidebar-icon-shadow": {
			value: " 0.0px 0.0px 13.0px 23.0px rgba(1, 33, 49, 1.0)"
		}
	}
};

var shadow = {
	topbar: {
		"topbar-icon-shadow": {
			value: " 0.0px 13.0px 24.0px 0px rgba(0, 0, 0, 0.35)"
		}
	}
};

var spaces = {
	"space-xxxs": {
	value: "4px"
},
	"space-xxs": {
	value: "8px"
},
	"space-xs": {
	value: "16px"
},
	"space-s": {
	value: "24px"
},
	"space-m": {
	value: "32px"
},
	"space-l": {
	value: "48px"
},
	"space-xl": {
	value: "64px"
},
	"space-xxl": {
	value: "96px"
}
};

var body = {
	"body-big": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "18px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "26px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"body-big-light": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Light'"
		},
		"font-size": {
			value: "18px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "26px"
		},
		"font-weight": {
			value: "300"
		},
		color: {
			value: "black"
		}
	},
	"body-big-semibold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "18px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "26px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"body-normal": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"body-normal-light": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Light'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "300"
		},
		color: {
			value: "black"
		}
	},
	"body-normal-medium": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Medium'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "500"
		},
		color: {
			value: "black"
		}
	},
	"body-normal-semibold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"body-small": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"body-small-semibold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"body-small-italic": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Italic'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		"font-style": {
			value: " italic"
		},
		color: {
			value: "black"
		}
	}
};

var button = {
	"button-big": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	"button-small": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	}
};

var headline = {
	h1: {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif'"
		},
		"font-size": {
			value: "32px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "37px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	h2: {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "24px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "31px"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	h3: {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif'"
		},
		"font-size": {
			value: "20px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "25px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	h4: {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	}
};

var link = {
	"link-big": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Medium'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "500"
		},
		"text-decoration": {
			value: " underline"
		},
		color: {
			value: "black"
		}
	},
	"link-small": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "13px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		"text-decoration": {
			value: " underline"
		},
		color: {
			value: "black"
		}
	}
};

var tooltip = {
	"tooltip-text": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	}
};

var table = {
	"header-row-title-bold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "700"
		},
		"text-transform": {
			value: " uppercase"
		},
		color: {
			value: "black"
		}
	},
	"row-text-primary": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "13px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"row-text-secondary": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "11px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"row-text-primary-underlined": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "13px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "400"
		},
		"text-decoration": {
			value: " underline"
		},
		color: {
			value: "black"
		}
	}
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var defaultDidomiPreflight = {
  h1: apply(_templateObject || (_templateObject = _taggedTemplateLiteral(["font-serif text-h1 font-normal tracking-h1 leading-h1"]))),
  h2: apply(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["font-sans text-h2 font-bold tracking-h2 leading-h2"]))),
  h3: apply(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["font-serif text-h3 font-normal tracking-h3 leading-h3"]))),
  h4: apply(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["font-sans text-h4 font-semibold tracking-h4 leading-h4"]))),
  body: apply(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["font-sans text-body-normal tracking-body leading-body"])))
};
var theme = {
  screens: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px'
  },
  extend: {
    colors: {
      neutral: {
        gray: {
          0: Neutral['grey-0'].value,
          1: Neutral['grey-1'].value,
          2: Neutral['grey-2'].value,
          3: Neutral['grey-3'].value,
          4: Neutral['grey-4'].value,
          5: Neutral['grey-5'].value,
          6: Neutral['grey-6'].value,
          7: Neutral['grey-7'].value,
          8: Neutral['grey-8'].value,
          9: Neutral['grey-9'].value
        },
        white: Neutral.white
      },
      primary: {
        blue: {
          1: Primary['blue-1'].value,
          2: Primary['blue-2'].value,
          3: Primary['blue-3'].value,
          4: Primary['blue-4'].value,
          5: Primary['blue-5'].value,
          6: Primary['blue-6'].value
        },
        pink: {
          1: Primary['pink-1'].value,
          2: Primary['pink-2'].value,
          3: Primary['pink-3'].value,
          4: Primary['pink-4'].value
        }
      },
      secondary: {
        'cobalt-blue': {
          1: Secondary['cobalt-blue-1'].value,
          3: Secondary['cobalt-blue-3'].value
        },
        'green': {
          1: Secondary['green-1'].value,
          3: Secondary['green-3'].value
        },
        'purple': {
          1: Secondary['purple-1'].value,
          3: Secondary['purple-3'].value
        },
        'red': {
          1: Secondary['red-1'].value,
          3: Secondary['red-3'].value,
          4: Secondary['red-4'].value
        },
        'yellow': {
          1: Secondary['yellow-1'].value,
          3: Secondary['yellow-3'].value
        }
      }
    },
    boxShadow: {
      'chat-icon': shadow$4.chat['chat-icon-shadow'].value,
      'button-hover': shadow$2.button['shadow-hover'].value,
      'button-label': shadow$2.button['shadow-label'].value,
      'button-pressed': shadow$2.button['shadow-pressed'].value,
      'dropdown-big': shadow$3.dropdown['dropdown-big'].value,
      'login-card': shadow$5.login.card.value,
      'sidebar-icon': shadow$1.sidebar['sidebar-icon-shadow'].value,
      'topbar-icon': shadow.topbar['topbar-icon-shadow'].value,
      'input-focused': "0 0 0 3px ".concat(Primary['blue-2'].value)
    },
    spacing: {
      xxxs: spaces['space-xxxs'].value,
      xxs: spaces['space-xxs'].value,
      xs: spaces['space-xs'].value,
      s: spaces['space-s'].value,
      m: spaces['space-m'].value,
      l: spaces['space-l'].value,
      xl: spaces['space-xl'].value,
      xxl: spaces['space-xxl'].value
    },
    gap: {
      xxxs: spaces['space-xxxs'].value,
      xxs: spaces['space-xxs'].value,
      xs: spaces['space-xs'].value,
      s: spaces['space-s'].value,
      m: spaces['space-m'].value,
      l: spaces['space-l'].value,
      xl: spaces['space-xl'].value,
      xxl: spaces['space-xxl'].value
    },
    fontFamily: {
      sans: [body['body-normal']['font-family'].value],
      serif: [headline['h1']['font-family'].value]
    },
    fontSize: {
      'body-normal': body['body-normal']['font-size'].value,
      'body-small': body['body-small']['font-size'].value,
      'body-big': body['body-big']['font-size'].value,
      'button-big': button['button-big']['font-size'].value,
      'button-small': button['button-small']['font-size'].value,
      'tooltip': tooltip['tooltip-text']['font-size'].value,
      'h1': headline.h1['font-size'].value,
      'h2': headline.h2['font-size'].value,
      'h3': headline.h3['font-size'].value,
      'h4': headline.h4['font-size'].value,
      'link-big': link['link-big']['font-size'].value,
      'link-small': link['link-small']['font-size'].value,
      'row-secondary': table['row-text-secondary']['font-size'].value
    },
    letterSpacing: {
      'h1': headline.h1['letter-spacing'].value,
      'h2': headline.h2['letter-spacing'].value,
      'h3': headline.h3['letter-spacing'].value,
      'h4': headline.h4['letter-spacing'].value,
      'body': body['body-normal']['letter-spacing'].value,
      'body-small': body['body-small']['letter-spacing'].value,
      'body-big': body['body-big']['letter-spacing'].value,
      'tooltip': tooltip['tooltip-text']['font-size'].value
    },
    lineHeight: {
      'h1': headline.h1['line-height'].value,
      'h2': headline.h2['line-height'].value,
      'h3': headline.h3['line-height'].value,
      'h4': headline.h4['line-height'].value,
      'body': body['body-normal']['line-height'].value,
      'body-big': body['body-big']['line-height'].value,
      'body-small': body['body-small']['line-height'].value,
      'tooltip': tooltip['tooltip-text']['font-size'].value
    },
    backgroundImage: {
      'pink-gradient': "radial-gradient(86.8% 86.8% at 0% 0%, #fef3ee 22.92%, #f4d0c4 100%)"
    }
  }
};

var connect = function connect(target) {
  var _config$theme;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  setup({
    preflight: function preflight(_preflight) {
      return config !== null && config !== void 0 && config.normalize ? _preflight : null;
    },
    plugins: _objectSpread2(_objectSpread2({}, defaultDidomiPreflight), config === null || config === void 0 ? void 0 : config.plugins),
    target: document.querySelector(target) || document.body,
    theme: _objectSpread2(_objectSpread2(_objectSpread2({}, theme), config === null || config === void 0 ? void 0 : config.theme), {}, {
      extend: _objectSpread2(_objectSpread2({}, theme.extend), config === null || config === void 0 ? void 0 : (_config$theme = config.theme) === null || _config$theme === void 0 ? void 0 : _config$theme.extend)
    }),
    mode: (config === null || config === void 0 ? void 0 : config.mode) || 'silent',
    variants: config === null || config === void 0 ? void 0 : config.variants,
    darkMode: config === null || config === void 0 ? void 0 : config.darkMode
  });
};

export { connect };
